import React from "react";
import { Button, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import Api from "../../api";
import { userStore } from "../../stores/UserStore";
import { showError } from "../../utils";
import { DownloadOutlined, FileTextOutlined } from "@ant-design/icons";
import { SectionCard } from "../../Components/SectionCard";
type InvoiceStatus = "draft" | "open" | "paid" | "uncollectible" | "void";
type Invoice = {
  id: string;
  number: string;
  amount_paid: number;
  date: number;
  status: InvoiceStatus;
};

export const StripeInvoiceList = () => {
  const [invoices, setInvoices] = useState<Invoice[]>([]);
  const [loadingOrders, setLoadingOrders] = useState<string[]>([]);
  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const _invoices: any = await Api.get(
          `/api/users/${userStore.userInfo?.user_id}/stripe_invoices`
        );
        setInvoices(_invoices);
      } catch (error) {
        console.error("Failed to get user orders", error);
      }
    };

    fetchOrders();
  }, []);

  const columns = [
    {
      title: "Date",
      key: "timestamp",
      render: (x: Invoice) => new Date(x.date * 1000).toLocaleDateString(),
    },

    {
      title: "Amount Charged",
      key: "price_paid",
      render: (x: Invoice) => "€" + x.amount_paid / 100, //is stored as an integer so 1000 = 10.00 euros
    },
    {
      title: "",
      key: "download",
      render: (x: Invoice) => downloadInvoiceButton(x),
    },
  ];
  const downloadInvoiceButton = (invoice: Invoice) => {
    const loading = loadingOrders.includes(invoice.id);
    return (
      <Tooltip title="Download Invoice">
        <Button
          style={{ width: 46, height: 32 }}
          loading={loading}
          disabled={loading}
          onClick={async () => {
            setLoadingOrders([...loadingOrders, invoice.id]);
            await downloadInvoice(invoice);
            setLoadingOrders(loadingOrders.filter((x) => x === invoice.id));
          }}
        >
          {!loading && <DownloadOutlined />}
        </Button>
      </Tooltip>
    );
  };

  if (invoices.length === 0) return null;
  return (
    <SectionCard
      icon={<FileTextOutlined />}
      title="Invoices"
      description="Download invoices for your past Hero Zone payments"
      noPadding
    >
      <Table
        dataSource={invoices}
        columns={columns}
        size="small"
        scroll={{ x: "max-content" }}
        pagination={false}
      />
    </SectionCard>
  );
};

async function downloadInvoice(invoice: Invoice) {
  try {
    const invoiceData = await Api.get(
      `/api/users/${userStore.userInfo?.user_id}/stripe_invoices/${invoice.id}`,
      {},
      { responseType: "arraybuffer" }
    );
    const file = new Blob([invoiceData], { type: "application/pdf" });

    const fileURL = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = `invoice_${invoice.number}.pdf`;
    link.click();
  } catch (error) {
    showError("Failed to download order invoice", error);
  }
}
